<template>
  <div class="GlobalFormDemo">
    <GlobalForm ref="orderForm" :form-item-list="formItemList" :init-data="initData" :inline="true" :labelWidth="80"
      :needBtnLoading="true" round @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item :label-width="'80px'" label="下单厂商" slot="manufacturerType">
        <el-select placeholder="请先选择下单厂商" @change="manufacturerTypeChange" filterable clearable
          v-model="manufacturerType">
          <el-option v-for="item in manufacturerList" :key="item.id" :label="item.name" :value="item.manufacturerType">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label-width="'80px'" label="外部渠道" slot="outType">
        <el-select placeholder="请先选择外部渠道" :disabled="isDisabled" filterable clearable v-model="outType">
          <el-option v-for="item in outTypeList" :key="item.outType" :label="item.channelName" :value="item.outType">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态" slot="stateList" style="margin:0">
        <el-select v-model="stateList" multiple placeholder="请选择订单状态" clearable>
          <el-option v-for="item in orderStatusList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="回收商家" slot="merchantId" style="margin:0">
        <el-select v-model="merchantId" placeholder="请选择" filterable clearable>
          <el-option v-for="item in shanpsSelectList" :key="item.merchantId"
            :label="item.merchantEnterType == '01' ? item.merchantName + '(外部)' : item.merchantName"
            :value="item.merchantId"></el-option>
        </el-select>
      </el-form-item>
    </GlobalForm>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
import { http } from "@/utils/request/masterSlaveMerchantOrder";

export default {
  data() {
    return {
      initData: {
        entryTime: [
          moment().day(moment().day()).format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
      },
      formItemList: [
        {
          key: "orderNo",
          type: "input",
          labelName: "繁星订单号",
          placeholder: "请输入繁星订单号",
        },
        {
          key: "imei",
          type: "input",
          labelName: "旧机串号",
          placeholder: "请输入旧机串号",
        },
        {
          key: "orderNoOut",
          type: "input",
          labelName: "外部单号",
          placeholder: "请输入外部单号",
        },
        {
          labelName: "下单商户",
          key: "createCompanyId",
          clear: true,
          type: "selectFilterable",
          placeholder: "请选择下单商户",
          option: [],
          clearFun: () => false,
        },
        { slotName: "manufacturerType" },
        { slotName: "outType" },
        {
          key: 'entryTime',
          type: "pickerOptions",
          labelName: '下单时间',
          placeholder: '请选择下单时间',
          valueFormat: "timestamp",
          clearable: true,
        },
        {
          key: "isFXGet",
          type: "select",
          labelName: "繁星是否中标",
          lableWidth: '100px',
          option: [
            {
              value: null,
              label: "全部",
            },
            {
              value: true,
              label: "是",
            },
            {
              value: false,
              label: "否",
            },
          ],
        },
        { slotName: "stateList" },
        { slotName: "merchantId" },

      ],
      manufacturerType: '',
      outType: "",
      manufacturerList: [],
      outTypeList: [],
      isDisabled: true,
      orderStatusList: [],
      stateList: [],
      shanpsSelectList: [],
      merchantId: "",

    };
  },
  created() {
    this.handleConfirm(this.initData)
    http.downListManufacturer().then((res) => {
      this.manufacturerList = res.data
    })
    _api.getSelectList().then((res) => {
      if (res.code === 1) {
        this.formItemList[3].option = res.data.map((v) => {
          return {
            label: v.name,
            value: v.id,
          };
        });
      }
    });
    _api.orderStatusList().then((res) => {
      let arr = [];
      for (const item of res.data) {
        arr.push({
          value: item.key,
          label: item.value,
        });
      }
      this.orderStatusList = arr;
    });
    _api.listSimpleMerchantView({
      pageNum: 0,
      pageSize: 999,
    }).then((res) => {
      if (res.code === 1) {
        this.shanpsSelectList = res.data;
      }
    });
  },
  mounted() {
  },
  methods: {

    manufacturerTypeChange(e) {
      console.log(e, 111);
      this.outTypeList = []
      this.outType = ''
      this.isDisabled = true
      if (e) {
        http.channelList({
          id: this.manufacturerList.find(item => item.manufacturerType === e).id
        }).then((res) => {
          this.outTypeList = res.data
        })
        this.isDisabled = false
      }
    },
    handleConfirm(data, cd) {
      let startTime = "";
      let endTime = "";
      console.log('entryTime', data.entryTime);

      if (data.entryTime === null) {
        startTime = null
        endTime = null
      } else {
        startTime = moment(data.entryTime[0]).format("x")
        endTime = moment(data.entryTime[1]).format("x")
      }
      console.log("提交了form", data);
      this.$store.commit("tagsView/SEACH_PARAMS", {
        ...data,
        startTime,
        endTime,
        manufacturerType: this.manufacturerType,
        outType: this.outType,
        stateList: this.stateList,
        merchantId: this.merchantId,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss"></style>